import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchReservation, openGlobalPopup } from "../../redux/action";
import CommonSearchBox from "../../component/SearchBox/CommomSearchBox"
import EmptyScreen from "../../component/common/EmptyScreen";
import { useTranslation } from "react-i18next";
import { SectionLoader } from "../../component/common/Loader";

function ReservationList({ onEdit, onStatus, onView }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [search, setSearch] = useState("");
  const { reservations, loading, error } = useSelector((state) => state.admin);

  // const reservations = [
  //   { id: 1, name: "Rahul Sharma", mobile: "+91 9876543210", date: "2025-12-31", time: "19:30", guests: 4, table: "T5", status: "Confirmed" },
  //   { id: 2, name: "Anita Rao", mobile: "+91 9123456789", date: "2025-12-31", time: "20:00", guests: 2, table: "T3", status: "Pending" },
  // ];

  useEffect(() => {
    dispatch(fetchReservation());
  }, [dispatch]);

  const handleEdit = (reservation) => {
    onEdit();
    dispatch({
      type: "EDIT_RESERVATION",
      payload: reservation
    });
  };


  const filteredReservations = Object.values(reservations).filter((reservation) => {
    const reservationDate = reservation.reservationDate
      ? reservation.reservationDate.split("T")[0].toLowerCase()
      : "";

    return (
      reservation.customerName?.toLowerCase().includes(search.toLowerCase()) ||
      reservation.tableName?.toString().includes(search) ||
      reservation.mobileNumber?.toLowerCase().includes(search.toLowerCase()) ||
      reservation.status?.toLowerCase().includes(search.toLowerCase()) ||
      reservationDate.includes(search.toLowerCase()) ||
      reservation.numberOfGuests?.toString().includes(search) ||
      reservation.reservationTime?.toLowerCase().includes(search.toLowerCase())
    );
  });

  // const handleUpdate = () => {
  //   // dispatch(updateReservation(editReservation));
  // };

  return (
    <div className="table-container">
      <h3 style={{ padding: "0px 0px 0px 10px" }}>{t("Reservations")} ({filteredReservations.length})</h3>
         <CommonSearchBox
            placeholder="Search customer,mobile,table number,status,time..."
            search={search}
            setSearch={setSearch}
          />

      {loading ? (
        <SectionLoader label="Loading reservations..." rows={4} />
      ) : filteredReservations.length === 0 ? (
        <EmptyScreen message="No orders found for the selected date range." />
      ) : (
        <>
       
          <div className="table-wrapper">
            <table className="table">
              <thead>
                <tr style={{ background: "var(--ui-surface-muted)" }}>
                  <th>Customer</th>
                  <th>Mobile</th>
                  <th>Date</th>
                  <th>Time</th>
                  <th>Guests</th>
                  <th>Table</th>
                  <th>Status</th>
                  <th>Source</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredReservations.map((res) => (
                  <tr key={res.reservationId}>
                    <td>{res.customerName}</td>
                    <td>{res.mobileNumber}</td>
                    <td>{res.reservationDate.split("T")[0]}</td>
                    <td>{res.reservationTime}</td>
                    <td>{res.numberOfGuests}</td>
                    <td>T-{res.restaurantTable.tableName}</td>
                    <td>{res.status}</td>
                    <td><span className="reservation-source">{res.sourceChannel || "Manual"}</span></td>
                    <td>
                      <span
                        className="edit-icon link-btn"
                        title="Edit"
                        aria-label="Edit"
                        onClick={() => handleEdit(res)}
                      >
                        ✎
                      </span>
                      <button type="button" className="link-btn" onClick={() => onView(res)}>View details</button>

                      {(res.status === "Confirmed" || res.status === "Booked") && <button type="button" className="link-btn" onClick={() => onStatus(res, "CheckedIn")}>Check in</button>}
                      {res.status === "CheckedIn" && <button type="button" className="link-btn" onClick={() => onStatus(res, "Completed")}>Complete</button>}
                      {(res.status === "Confirmed" || res.status === "Booked") && <button type="button" className="link-btn" onClick={() => onStatus(res, "NoShow")}>No-show</button>}
                      {!["Completed", "Cancelled", "NoShow"].includes(res.status) && <button type="button" className="link-btn danger" onClick={() => onStatus(res, "Cancelled")}>Cancel</button>}

                      {/* <span
    className="delete-icon link-btn danger"
    title="Delete"
    aria-label="Delete"
   
  >
    ✖
  </span> */}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>)
      }
    </div>
  );
}

export default ReservationList;
